import { useEffect } from 'react';

/** Read by `smartLinksNavbar.scss`: the new mobile top bar is on screen. */
export const MOBILE_NAV_BODY_CLASS = 'm24-mobile-nav';

/**
 * The old `SmartLinksNavbar` sits above every Music24 page, outside `SMLContainer`, so it cannot
 * know that `MobileNav` draws the top bar now. While a page with the new navigation is mounted,
 * this marks the body and the navbar's stylesheet hides the old bar for signed-in readers. Pages
 * outside `SMLContainer` (the SmartLink editors) keep the old bar.
 */
export function useHideLegacyMobileNavbar(isActive: boolean): void {
  useEffect(() => {
    if (!isActive) {
      return undefined;
    }
    document.body.classList.add(MOBILE_NAV_BODY_CLASS);
    return () => document.body.classList.remove(MOBILE_NAV_BODY_CLASS);
  }, [isActive]);
}
